import { useCreateMarketMutation, useEditMarketMutation } from "../../../api/marketApi";

/**
 * Data/API Layer - mirrors _features/company/modals/CompanyFormModal/
 * hooks/useCompanyFormMutations.js, trimmed down: Markets has no logo
 * upload and no self-serve-user edit branch, just create/edit.
 */
export function useMarketFormMutations() {
  const [createMarket, { isLoading: isCreating }] = useCreateMarketMutation();
  const [updateMarket, { isLoading: isUpdating }] = useEditMarketMutation();

  async function submitMarket({ mode, validData, rowData }) {
    if (mode === "create") {
      return await createMarket(validData).unwrap();
    }

    return await updateMarket({ ...validData, _id: rowData?._id }).unwrap();
  }

  return {
    submitMarket,
    isSubmitting: isCreating || isUpdating,
  };
}
